enum UnsharpeningMode {
  AUTO = 'auto',
  NONE = 'none',
  ALWAYS = 'always',
}

export default UnsharpeningMode;
